/** Utah's words for onboarding.ts: the food handler course and permit card, as a new worker sees them. */
export const ONBOARDING_UT = {
  /** The state's required food handler course (Utah: course within 14 days of starting food work); the step's name. */
  courseName: "Utah food handler course",
  /** Tells a blocked worker to add their food handler permit card and when it is due (Utah: county permit within 30 days of starting). */
  permitCardLine: "Add your Utah food handler permit. Utah needs it within 30 days of starting.",
} as const;
